import React, { useEffect } from 'react';
import styles from './Landing.module.css';

const Landing = () => {
    // const [windowWidth, setWindowWidth] = useState
    function handleClick(e) {
        window.location.href = '/#projects';
    }

    // useEffect(() => {

    // }, [windowWidth, setWindowWith])
    
    return (
        <div className={styles.container}>
            <div className={styles.phrase}>
                <div className={styles.firstLine}>
                    <h1 className={styles.hi}>Hi, I'm</h1>
                    <div className={styles.smokyContainer}>
                        <h1 className={styles.name}>Andres Frank</h1>
                        <h1 className={styles.dot}>.</h1>
                        {/* <ul className={styles.smoky}>
                            <li>A</li>
                            <li>n</li>
                            <li>d</li>
                            <li>r</li>
                            <li>e</li>
                            <li>s</li>
                            <li>F</li>
                            <li>r</li>
                            <li>a</li>
                            <li>n</li>
                            <li>k</li>
                            <li>.</li>
                        </ul> */}
                    </div>
                </div>
                    <div className={styles.secondLine}>
                        <h1 className={styles.fullstack}>Front-End Developer
                            <strong className={styles.redDot}>.</strong>
                        </h1>
                    </div>
            </div>
            <div className={styles.btnContainer}>
                <button className={styles.btn} onClick={e => handleClick(e)}>VIEW PROJECTS</button>            
            </div>
        </div>
    )
}

export default Landing;